import { useCallback, useEffect, useState } from "react";
import { useAppSelector } from "src/hooks/redux";
import { displayDigits, getChangeAndChangePercentage } from "src/utils/methods";
import { heartBeatData, subscribeToData, unsubscribeDataByScrip, } from "src/utils/websocketwrapper";
import { SESSION_KEYS, getDataFromSession } from "src/utils/session-storage";
// const componentName = "CommonLtpRenderer";
const CommonLtpRenderer = ({ scripCode, exch, exchType, renderElement, ltp, prevLtp, componentName, }) => {
    const [updatedLtp, updateLtp] = useState(ltp);
    const [updatedPrevLtp, updatePrevLtp] = useState(prevLtp);
    const openFeedWsHeartBeat = useAppSelector((state) => {
        // console.log("THis is a tribute to heartbeat", state.openFeedWs.heartBeat);
        return state.openFeedWs.heartBeat;
    });
    useEffect(() => {
        // if (componentName == "IndicesBar" && scripCode == 999920000) {
        //   console.log("This is a tribute common ltp props change", Date.now());
        // }
    }, [scripCode, exch, exchType, renderElement, ltp, prevLtp, componentName]);
    // const openFeedWsMsg = useAppSelector((state) => {
    //   if (scripCode === 0) {
    //     return;
    //   }
    //   if (state.openFeedWs.message?.LastRate != undefined) {
    //     if (
    //       state.openFeedWs.message &&
    //       state.openFeedWs.message.Token == scripCode
    //     ) {
    //       // if (scripCode == 999920041) {
    //       //   console.log("This is a tribute", update);
    //       // }
    //       //
    //       return state.openFeedWs.message;
    //     }
    //   }
    //   return undefined;
    // });
    // if (scripCode == 999920000) {
    //   console.log(LtpChangeObj);
    //   console.log(ltp, prevLtp);
    //   console.log(updatedLtp, updatedPrevLtp);
    // }
    const updateIndexLtp = useCallback((update) => {
        if (scripCode === 0) {
            return;
        }
        // if (componentName == "OptionChain1" && scripCode == 999920000) {
        //   console.log(
        //     "This is a tribute common ltp rerender updateIndexLtp",
        //     Date.now(),
        //     update
        //   );
        // }
        if (scripCode == (update === null || update === void 0 ? void 0 : update.Token) && update.LastRate != undefined) {
            // if (scripCode == 999920000) {
            //   // eslint-disable-next-line no-debugger
            //   debugger;
            // }
            // if (scripCode == 999920041) {
            //   console.log("This is a tribute 2", update);
            // }
            updateLtp(update === null || update === void 0 ? void 0 : update.LastRate);
            // if (prevLtp != update?.PClose) {
            //   if (componentName == "IndicesBar" && scripCode == 999920000) {
            //     console.log(
            //       "This is a tribute common ltp prevLtpUpdated",
            //       Date.now()
            //     );
            //   }
            updatePrevLtp(update === null || update === void 0 ? void 0 : update.PClose);
            // }
        }
    }, [scripCode, exch, exchType]);
    useEffect(() => {
        if (scripCode) {
            sendWsMessage(openFeedWsHeartBeat, "Subscribe", scripCode);
            //console.log(openFeedWsHeartBeat)
            //   sendWsMessage(openFeedWsHeartBeat, "Subscribe", scripCode);
        }
    }, [openFeedWsHeartBeat, updateIndexLtp, componentName]);
    useEffect(() => {
        // if (scripCode == 999920000) {
        //   // eslint-disable-next-line no-debugger
        //   debugger;
        // }
        if (ltp != undefined) {
            updateLtp(ltp);
        }
        if (prevLtp != undefined) {
            updatePrevLtp(prevLtp);
        }
    }, [ltp, prevLtp]);
    const sendWsMessage = (heartBeatMessage, operation, tokensInfo) => {
        if (tokensInfo == undefined) {
            return;
        }
        const method1 = {
            Method: "MarketFeedV3",
            Operation: operation,
            ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
            MarketFeedData: [
                {
                    Exch: exch,
                    ExchType: exchType,
                    ScripCode: tokensInfo,
                },
            ],
        };
        // console.log(method1);
        if (heartBeatMessage) {
            heartBeatData(method1, componentName, updateIndexLtp);
        }
        else {
            subscribeToData(method1, componentName, updateIndexLtp);
        }
    };
    // useEffect(() => {
    //   if (openFeedWsMsg) {
    //     updateIndexLtp(openFeedWsMsg);
    //   }
    // }, [openFeedWsMsg]);
    // if (componentName == "IndicesBar" && scripCode == 999920000) {
    //   console.log("This is a tribute common ltp rerender", Date.now());
    // }
    //unmount effect
    useEffect(() => {
        return () => {
            if (scripCode) {
                // if (componentName == "IndicesBar" && scripCode == 999920000) {
                //   console.log("This is a tribute unsubscribe 3", scripCode);
                // }
                unsubscribeDataByScrip(componentName, {
                    Exch: exch,
                    ExchType: exchType,
                    ScripCode: scripCode,
                });
            }
        };
    }, [exch, exchType, scripCode]);
    return renderElement(displayDigits(exchType, updatedLtp), displayDigits(exchType, updatedPrevLtp), getChangeAndChangePercentage(updatedLtp ? updatedLtp : 0, updatedPrevLtp ? updatedPrevLtp : 0), updatedLtp, updatedPrevLtp);
    // <div className={`${styles.oiView} medium`}>
    //   <span className={`${styles.number}`}>{intComma(updatedLtp)}</span>
    //   <span
    //     className={`${styles.callPutPerc} ${
    //       LtpChangeObj.isNegative ? "negativeText" : "positiveText"
    //     }`}
    //   >
    //     &nbsp;({LtpChangeObj.differencePercentage})
    //   </span>
    // </div>
};
export default CommonLtpRenderer;
